import { Directive, Input, OnDestroy } from '@angular/core';
import { MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';

@Directive({
  selector: '[appAutocompleteScroll]'
})
export class AutocompleteScrollDirective implements OnDestroy {
  private matAutocompleteTrigger: MatAutocompleteTrigger;

  @Input() set appAutocompleteScroll(value: MatAutocompleteTrigger) {
    this.matAutocompleteTrigger = value;
    document.getElementById('app-body').addEventListener('scroll', this.scrollEvent, true);
  }

  private scrollEvent = (): void => {
    if (this.matAutocompleteTrigger == null) {
      return;
    }
    if (this.matAutocompleteTrigger.panelOpen) {
      // this.matAutocompleteTrigger.updatePosition();
      this.matAutocompleteTrigger.closePanel();
    }
  };

  ngOnDestroy() {
    document.getElementById('app-body').removeEventListener('scroll', this.scrollEvent, true);
  }
}
